import styled from "styled-components";

export const LinkComponentWrapper = styled.span<{ isFormHint: boolean }>`
  font-size: ${({ theme, isFormHint }) =>
    isFormHint ? theme.fontSizes.xs : theme.fontSizes.sm};

  && > a {
    font-size: ${({ theme, isFormHint }) =>
      isFormHint ? theme.fontSizes.xs : theme.fontSizes.sm};
  }
`;
